export const SESSION_EXPIRED_REASON = 'session_expired';
export const SESSION_EXPIRED_LOGIN_PATH = `/login?reason=${SESSION_EXPIRED_REASON}`;

// Multiple in-flight requests can all hit a dead session at once; only redirect once.
let redirectInitiated = false;

export function forceSessionExpiredLogout() {
    if (redirectInitiated) return;

    // Already on the login page: a deliberate logout is in progress (or the user is
    // signing in) — don't show a misleading "session expired" banner over it.
    if (window.location.pathname === '/login') return;

    redirectInitiated = true;
    localStorage.removeItem(process.env.REACT_APP_JWT_KEY);
    window.location.assign(SESSION_EXPIRED_LOGIN_PATH);
}
